import { render, staticRenderFns } from "./ActivityItemContent.vue?vue&type=template&id=15d429b8&scoped=true&"
import script from "./ActivityItemContent.vue?vue&type=script&lang=js&"
export * from "./ActivityItemContent.vue?vue&type=script&lang=js&"
import style0 from "./ActivityItemContent.vue?vue&type=style&index=0&id=15d429b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d429b8",
  null
  
)

export default component.exports